// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.signing.LeasingUserSigningOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { WhoHasSignedFromOuidWebApiResponseDto } from '../..';

interface MarkAsSignedFromOuidParams {
  ouid: string;
}
interface WhoHasSignedFromOuidParams {
  ouid: string;
}

export const LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Path = '/api/web/v1/ouid/markAsSignedFromOuid';

/**
 * marks the lease as signed for user from ouid
 */
export const LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid = (
  getParams: MarkAsSignedFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<MarkAsSignedFromOuidParams, never, void>(
    {
      getParams: getParams,
      endpoint: LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_Path = '/api/web/v1/ouid/whoHasSignedFromOuid';

/**
 * get list of users for signing with ouid to reset tenant association
 */
export const LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid = (
  getParams: WhoHasSignedFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<WhoHasSignedFromOuidParams, never, WhoHasSignedFromOuidWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
